<template>
  <button
    :class="['c-documents-modal__exercise', current ? 'c-documents-modal__exercise--current' : '']"
    @click="select"
    @keydown="select"
  >
    <div class="c-documents-modal__exercise-name">
      {{ name }}
    </div>
    <div class="c-documents-modal__exercise-details">
      <div class="c-documents-modal__exercise-category">
        <div class="c-documents-modal__exercise-genre">
          <FileIcon />
          {{ genreName }}
        </div>

        <div class="c-documents-modal__exercise-size">{{ formatSize(attachmentSize) }}</div>
      </div>
      <div class="c-documents-modal__exercise-attachments">
        {{ $t('EXERCISE.ATTACHMENT_COUNT') }}
        <span class="c-documents-modal__exercise-attachment-count">{{ attachmentCount }}</span>
      </div>
    </div>
  </button>
</template>

<script lang="ts" setup>
import { formatSize } from '@/utils/format-size';
import FileIcon from '@/assets/icons/FileIcon.vue';
import { KEYS_SPACEBAR_ENTER } from '@/utils/keyboard';

interface ExercisePreviewProps {
  name: string;
  genreName: string;
  attachmentSize: number;
  attachmentCount: number;
  current: boolean;
}

defineProps<ExercisePreviewProps>();

const emit = defineEmits<{
  select: [];
}>();

const select = (event) => {
  if (event instanceof KeyboardEvent && !KEYS_SPACEBAR_ENTER.includes(event.key.toLowerCase())) {
    return;
  }

  event.preventDefault();

  emit('select');
};
</script>
